module.exports = __webpack_public_path__ + "static/media/symbolic-calculation.d3205e45.png";